import React from "react";

const OurStatic = () => {
  const cardStyle = {
    boxShadow: "0px 7px 16px 0px rgba(172, 153, 153, 0.5)",
    padding: "20px",
    backgroundColor: "#fff",
    height: "420px",
    display: "flex",
    flexDirection: "column",
    // justifyContent: "space-between",
  };

  const imageStyle = {
    height: "250px",
    width: "100%",
    objectFit: "cover",
    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
    borderRadius: "8px",
  };

  const textStyle = {
    textAlign: "justify",
    lineHeight: "1.6",
    fontSize: "15px",
  };

  const headingStyle = {
    borderBottom: "3px solid #ffcc00",
    display: "inline-block",
    marginBottom: "15px",
  };

  return (
    <div className="container-fluid py-4" style={{ backgroundColor: "#f3f3f3" }}>
      <div class className="container">
        <div className="row g-4">
          {/* --- BIBLE DIARY CARD --- */}
          <div className="col-md-6 col-12">
            <div style={cardStyle}>
              <h2 className="entry-title" style={headingStyle}>Bible Diary</h2>
              <div className="d-flex align-items-center">
                <div className="text-center" style={{ flex: "1" }}>

                  <img
                    src={process.env.PUBLIC_URL + "/images/all-img/Capture.jpeg"}
                    alt="Bible Diary QR Code"
                    style={{
                      width: "200px",
                      height: "200px",
                      objectFit: "contain",
                      border: "2px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#fff",
                      padding: "8px",
                    }}
                  />


                  <div className="text-center text-dark mt-2" style={{ fontSize: "13px", fontWeight: "500" }}>
                    <p style={{ marginBottom: "4px" }}>Scan the QR code for Bible Diary 2025</p>
                    <p style={{ marginBottom: "4px" }}>or</p>
                    <p style={{ marginBottom: "10px" }}>
                      Click the button below to download the Bible Diary app directly!
                    </p>
                    <button
                      type="button"
                      className="btn btn-dark btn-sm"
                      onClick={() =>
                        window.open(
                          "https://play.google.com/store/apps/details?id=com.gmail.bromartinfsc.biblediary",
                          "_blank"
                        )
                      }
                    >
                      Download
                    </button>
                  </div>



                  <div className="ms-3" style={{ flex: "2", textAlign: "justify" }}>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* --- BRO. ARMIN LUISTRO CARD --- */}
          <div className="col-md-6 col-12">
            <div style={cardStyle}>
              <h2 className="entry-title" style={headingStyle}>
                Bro. Armin Luistro, FSC
              </h2>
              <div className="d-flex">
                <div style={{ flex: "2" }}>
                  <p style={textStyle}>
                    This valuable daily prayer resource is a rich treasure for all
                    Lasallians. It provides a host of helpful elements to enrich one’s
                    prayer life. For each day of 2024, daily liturgical details, the daily
                    saint, and daily scriptural readings are provided — each reading
                    accompanied by a thoughtful reflection written by a Brother.
                    Pages from this resource can be printed and shared in Lasallian
                    communities or schools.
                  </p>
                  <button
                    type="button"
                    className="btn btn-dark btn-sm mt-2"
                    onClick={() =>
                      window.open("https://en.wikipedia.org/wiki/Armin_Luistro", "_blank")
                    }
                  >
                    Read More
                  </button>
                  <div className="ms-3" style={{ flex: "1" }}>
                  </div>
                </div>
                <div className="ms-3 text-center">
                  <a
                    href="https://en.wikipedia.org/wiki/Armin_Luistro"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="images/priestimage/Armin.jpg"
                      alt="Bro Armin"
                      style={{ ...imageStyle, width: "140px", height: "200px" }}
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default OurStatic;
